import React from "react";

const statusStyles = {
  Verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Ongoing: "bg-blue-50 text-blue-700 border-blue-200",
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Started: "bg-sky-50 text-sky-700 border-sky-200",
  Planning: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Designing: "bg-purple-50 text-purple-700 border-purple-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  Reviewing: "bg-cyan-50 text-cyan-700 border-cyan-200",
  Finalizing: "bg-orange-50 text-orange-700 border-orange-200",
  "On Hold": "bg-[#FFF3DD] text-[#AA8345] border-[#FCE7C8]",
  Completed: "bg-green-50 text-green-700 border-green-200",
  Cancelled: "bg-red-50 text-red-700 border-red-200",
};

const statusDot = {
  Verified: "bg-emerald-500",
  Ongoing: "bg-blue-500",
  Pending: "bg-amber-500",
  Started: "bg-sky-500",
  Planning: "bg-indigo-500",
  Designing: "bg-purple-500",
  "In Progress": "bg-blue-500",
  Reviewing: "bg-cyan-500",
  Finalizing: "bg-orange-500",
  "On Hold": "bg-[#AA8345]",
  Completed: "bg-green-500",
  Cancelled: "bg-red-500",
};

export default function StatusChip({ status }) {
  const baseClasses = "inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs font-semibold transition-all duration-200 hover:shadow-sm";
  const statusClass = statusStyles[status] || "bg-gray-50 text-gray-700 border-gray-200";
  const dotClass = statusDot[status] || "bg-gray-400";

  return (
    <span className={`${baseClasses} ${statusClass}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dotClass}`} aria-hidden="true" />
      <span>{status}</span>
    </span>
  );
}
